<div class="offer-card" [ngClass]="{ 'accepted': offerConfirmationInfo() }">
  <!-- Ribbon shown for Accepted or New -->
  @if (offerConfirmationInfo() !== null) {
    <div class="ribbon">
      <span>{{ 'myOffers.ribbon.accepted' | cxTranslate }}</span>
    </div>
  } @else {
    <div class="ribbon new">
      <span>{{ 'myOffers.ribbon.new' | cxTranslate }}</span>
    </div>
  }

  <div class="offer-content-wrapper">
    <!-- Header -->
    <header class="d-flex align-items-baseline justify-content-between flex-wrap">
      <h2 class="offer-title mb-0">
        @if (total > 1) {
          {{
          'myOffers.header.title'
          | cxTranslate: { index: index, total: total, name: offer.name }
          }}
        } @else {
          {{ offer.name }}
        }
      </h2>
    </header>

    <!-- Status Banner -->
    @if (offerConfirmationInfo() !== null) {
      <div class="offer-status accepted d-flex align-items-center">
        <img src="/icons/success.svg" alt="" class="mr-2" />
        <span>
          {{
          'myOffers.status.accepted'
          | cxTranslate: {
          date:
          (offerConfirmationInfo().confirmationDate
          | date: "MM/dd/yyyy"),
          time:
          (offerConfirmationInfo().confirmationDate
          | date: "shortTime")
        }
        }}
      </span>
    </div>
  } @else {
    <div class="offer-status pending d-flex align-items-center">
      <img src="/icons/clock.svg" alt="" class="mr-2" />
      <span>{{ 'myOffers.status.pending' | cxTranslate }}</span>
    </div>
  }

  <!-- Performance Summary (accepted or not, if data exists) -->
  @if (showPerformanceSummary) {
    <div
      class="performance-summary my-5"
      [ngClass]="{
          'perf--accepted': offerConfirmationInfo() !== null,
          'perf--not-accepted-card': offerConfirmationInfo() === null
        }"
      >
      @if (offerConfirmationInfo() !== null) {
        <!-- ACCEPTED VIEW (centered) -->
        <h2 class="text-center">
          {{ 'myOffers.performance.accepted.heading' | cxTranslate }}
        </h2>
        <div class="program-name text-center">{{ offer.name }}</div>
        <div class="selected-option text-muted mb-3 text-center">
          {{ 'myOffers.performance.accepted.selectedOption' | cxTranslate }}
          <strong>{{ acceptedTraitLabel(offer) }}</strong>
        </div>

        <div class="text-center">
          <div
            class="projected-rebate-title"
          [innerHTML]="
            'myOffers.performance.accepted.projectedTitle' | cxTranslate
          "
          ></div>
          <div class="projected-rebate-amount">
            {{ creditAmount | currency: 'USD':'symbol':'1.0-0' }}
          </div>
        </div>

        <hr />

        <!-- KPIs after acceptance -->
        <div class="row text-center">
          <div class="col-12 col-sm-4 mb-3 mb-sm-0">
            <div class="label">
              {{ 'myOffers.performance.accepted.kpi.scheduled' | cxTranslate }}
            </div>
            <div class="value">{{ scheduledDoses }}</div>
          </div>
          <div class="col-12 col-sm-4 mb-3 mb-sm-0">
            <div class="label">
              {{ 'myOffers.performance.accepted.kpi.shipped' | cxTranslate }}
            </div>
            <div class="value">{{ shippedDoses }}</div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="label">
              {{ 'myOffers.performance.accepted.kpi.totalPurchase' | cxTranslate }}
            </div>
            <div class="value">
              {{ totalPurchase | currency: 'USD':'symbol':'1.0-0' }}
            </div>
          </div>
        </div>

        <!-- Inline upgrade suggestion -->
        @if (canShowUpgrade(offer)) {
          <div class="upgrade-inline mt-4 p-3 rounded">
            <h3 class="h6 mb-2">
              {{ 'myOffers.performance.accepted.inline.heading' | cxTranslate }}
            </h3>
            <p
              class="mb-2"
          [innerHTML]="
            'myOffers.performance.accepted.inline.currentSelection'
              | cxTranslate: {
                  current: acceptedTraitLabel(offer),
                  currentAmount:
                    (creditAmount | currency: 'USD':'symbol':'1.0-0')
                }
          "
          ></p>
          <p
            class="mb-3"
          [innerHTML]="
            'myOffers.performance.accepted.inline.upgradeTarget'
              | cxTranslate: {
                  target: upgradeTargetLabel(offer),
                  targetAmount:
                    (projectedUpgradeAmount | currency: 'USD':'symbol':'1.0-0')
                }
          "
        ></p>
        <button
          class="btn btn-primary"
          type="button"
          (click)="upgradeOffer(maxTrait(offer)?.traitId)"
          >
          {{
          'myOffers.common.upgradeButton'
          | cxTranslate: { target: upgradeTargetLabel(offer) }
          }}
        </button>
        <small class="text-muted d-block mt-2">
          {{ 'myOffers.common.upgradeNote' | cxTranslate }}
        </small>
      </div>
    }

    @if (inlineBannerMessage()) {
      <div
        class="inline-banner inline-banner--success mb-1 d-flex align-items-start"
        role="status"
        aria-live="polite"
        >
        <img
          src="/icons/confirmation-positive-green.png"
          alt=""
          class="mr-2 mt-1"
          />
        <div class="inline-banner__text">
          @for (line of inlineBannerMessage()?.split('|'); track line; let i = $index) {
            <p class="mb-0" [class.font-weight-bold]="i === 0">{{ line }}</p>
          }
        </div>
      </div>
    }

    <div class="last-updated">
      {{
      'myOffers.performance.accepted.inline.lastUpdated'
      | cxTranslate: { date: (lastUpdated | date: 'MMMM d, y') }
      }}
    </div>

    <!-- Accepted: use backend disclaimer -->
    @if (offer.disclaimer) {
      <p class="disclaimer">
        <sup>*</sup> {{ offer.disclaimer }}
      </p>
    }

    <p class="disclaimer disclaimer--recalc">
      {{
      'myOffers.performance.accepted.inline.refreshNote' | cxTranslate
      }}
    </p>
  } @else {
    <!-- NOT-ACCEPTED TEASER (single amount from upgradeCreditAmount) -->
    <h2 class="text-center">
      {{ 'myOffers.performance.pending.heading' | cxTranslate }}
    </h2>
    <div class="program-name text-center">{{ offer.name }}</div>

    <div class="text-center my-3">
      <p class="explanation mb-1">
        {{ 'myOffers.performance.pending.subtitle' | cxTranslate }}
      </p>

      <div
        class="projected-rebate-title"
          [innerHTML]="
            'myOffers.performance.pending.projectedTitle' | cxTranslate
          "
      ></div>
      <div class="projected-rebate-amount">
        {{ projectedUpgradeAmount | currency: 'USD':'symbol':'1.0-0' }}
      </div>
    </div>

    <p class="mb-2 text-center">
      {{ 'myOffers.performance.pending.ctaDescription' | cxTranslate }}
    </p>
    <div class="text-center">
      <button
        class="btn btn-primary btn-sm"
        type="button"
        (click)="jumpToOfferDescription()"
        >
        {{ 'myOffers.performance.pending.ctaButton' | cxTranslate }}
      </button>
    </div>

    <hr />

    @if (offerConfirmationInfo() === null) {
      <p class="disclaimer">
        <sup>*</sup> {{ 'myOffers.disclaimer.estimatedCredit' | cxTranslate }}
      </p>
    }
  }
</div>
}

<!-- Offer Description -->
<div #offerDescriptionStart></div>
<div class="mt-5" [innerHTML]="offer.offerDescription | safe: 'html'"></div>

<!-- Offer Documents -->
@for (document of offer.documents; track $index) {
  <app-offer-document [document]="document" [baseurl]="baseurl" />
}

<!-- Acceptance Section (anchor for scroll) -->
<h2 class="offer-form-title mb-0" #acceptanceSection>
  {{ 'myOffers.acceptance.sectionHeading' | cxTranslate }}
</h2>
<div class="form-wrapper">
  @if (offerConfirmationInfo() !== null) {
    <div class="d-flex text-violet mt-4">
      <img src="/icons/success.svg" alt="" class="mr-2 align-top" />
      <p class="mb-0">
        <span class="d-block font-weight-bold">
          {{ 'myOffers.acceptance.congratsTitle' | cxTranslate }}
        </span>
        <span class="congratulation-message">
          {{
          'myOffers.acceptance.congratsMessage'
          | cxTranslate: {
          offer: offerConfirmationInfo().acceptedOfferTraitName,
          time:
          (offerConfirmationInfo().confirmationDate
          | date: "shortTime"),
          date:
          (offerConfirmationInfo().confirmationDate
          | date: "MM/dd/yyyy")
        }
        }}
      </span>
    </p>
  </div>

  @if (canShowUpgrade(offer) && !showPerformanceSummary) {
    <div class="upgrade-callout upgrade-dotted mt-4 p-3 rounded">
      <h3 class="h5 mb-2">
        {{ 'myOffers.acceptance.upgradeHeading' | cxTranslate }}
      </h3>
      <p
        class="mb-3"
          [innerHTML]="
            'myOffers.acceptance.upgradeMessage'
              | cxTranslate: {
                  current: acceptedTraitLabel(offer),
                  target: upgradeTargetLabel(offer)
                }
          "
    ></p>
    <button
      class="btn btn-primary"
      type="button"
      (click)="upgradeOffer(maxTrait(offer)?.traitId)"
      >
      {{
      'myOffers.common.upgradeButton'
      | cxTranslate: { target: upgradeTargetLabel(offer) }
      }}
    </button>
    <small class="text-muted d-block mt-2">
      {{ 'myOffers.common.upgradeNote' | cxTranslate }}
    </small>
  </div>
}
} @else {
  <app-offer-form
    [offer]="offer"
    [user]="user"
    (offerFormSubmission)="confirmOffer($event)"
    />
}
</div>

@if (
  offerConfirmationInfo() !== null &&
  (offer.successMessage || (offer.redirectionLinks?.length > 0))
  ) {
  <div class="success-block border-top pt-5 mt-5">
    @if (offer.successMessage) {
      <p class="mb-0">
        {{ offer.successMessage }}
      </p>
    }

    @for (redirectionLink of offer.redirectionLinks; track $index) {
      <a
        [href]="redirectionLink.url"
        class="text-decoration-none mt-4 d-block redirection-links"
        [ngClass]="{
              'btn-primary': redirectionLink.primary,
              'btn-secondary': !redirectionLink.primary
            }"
        >
        {{ redirectionLink.linkText }}
      </a>
    }
  </div>
}

<!-- Toast Notification -->
@if (showToastNotification()) {
  <div
    class="toast-notification"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    >
    <p class="mb-0">
      <img src="/icons/confirmation-positive-green.png" alt="" />
      {{ toastMessage() }}
    </p>
    <button
      class="toast-close"
        [attr.aria-label]="
          'myOffers.toast.closeLabel' | cxTranslate
        "
      (click)="closeToastNotification()"
      >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}
</div>
</div>
